import React, { useCallback } from "react";
import PropTypes from "prop-types";

import PlayerHeader from "core/components/PlayerHeader";
import SponsorPlayerLogo from "core/components/SponsorPlayerLogo";
import SponsorPlayerButton from "core/components/SponsorPlayerButton";
import SponsorMidAdv from "core/components/SponsorMidAdv";
import SponsorPauseAdv from "core/components/SponsorPauseAdv";
import SponsorLiveAdv from "core/components/SponsorLiveAdv";

// Интервал показа мидролов (в секундах) - 15 мин
const MIDROLL_IMPRESSION_INTERVAL = 60 * 15;

const videoStateShape = PropTypes.shape({
  status: PropTypes.oneOf(["playing", "paused"]),
  isUserPause: PropTypes.bool,
  isStarted: PropTypes.bool,
  isEnded: PropTypes.bool,
  rawProgramDateTime: PropTypes.string,
  muted: PropTypes.bool,
  paused: PropTypes.bool,
});

const videoActionsShape = PropTypes.shape({
  toggleMute: PropTypes.func,
  play: PropTypes.func,
  pause: PropTypes.func,
  togglePlayUser: PropTypes.func,
});

const channelContentShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  shareUrl: PropTypes.string.isRequired,
  isAdvEnabled: PropTypes.bool,
  widget: PropTypes.object,
  sport: PropTypes.shape({
    id: PropTypes.string,
  }),
  rightholder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
});

export default function ChannelScreenContent({
  content,
  videoState,
  videoActions,
  sponsorCornerBannerPlace,
  sponsorInStreamBannerPlace,
  sponsorPlayerLogoPlace,
  sponsorPlayerButtonPlace,
  sponsorVideoPlace,
  fullscreenTarget,
  controls = true,
  muted,
  autoPlay,
  closeRouteDialogButton,
}) {
  // Канал рендерится в iframe — высота не требует компенсации, т.к. оверлеи позиционируются абсолютно
  const setCornerBannerHeight = useCallback(() => {}, []);
  const setInStreamBannerHeight = useCallback(() => {}, []);

  if (!videoState) {
    return null;
  }

  const sponsorPlayerLogoVisible = true;
  const sponsorPlayerButtonVisible = true;

  return (
    <>
      {controls && (
        <PlayerHeader
          content={content}
          position="absolute"
          visible
          tracker
          closeRouteDialogButton={closeRouteDialogButton}
        />
      )}

      {content.isAdvEnabled && controls && (
        <SponsorPlayerLogo
          contentId={content.id}
          rightholderId={content.rightholder?.id}
          place={sponsorPlayerLogoPlace}
          footerVisible={false}
          visible={sponsorPlayerLogoVisible}
        />
      )}

      {content.isAdvEnabled && !content.widget && controls && (
        <SponsorPlayerButton
          contentId={content.id}
          rightholderId={content.rightholder?.id}
          place={sponsorPlayerButtonPlace}
          footerVisible={false}
          visible={sponsorPlayerButtonVisible}
        />
      )}

      {content.isAdvEnabled && (
        <>
          <SponsorLiveAdv
            fullscreenTarget={fullscreenTarget}
            videoActions={videoActions}
            videoState={videoState}
            content={content}
            rightholderId={content.rightholder?.id}
            sponsorVideoPlace={sponsorVideoPlace}
            muted={muted || autoPlay}
            impressionInterval={MIDROLL_IMPRESSION_INTERVAL}
            disabled={!sponsorPlayerLogoVisible || !sponsorPlayerButtonVisible}
          />

          <SponsorMidAdv
            isLive
            fullscreenTarget={fullscreenTarget}
            videoActions={videoActions}
            videoState={videoState}
            contentId={content.id}
            rightholderId={content.rightholder?.id}
            sponsorInStreamBannerPlace={sponsorInStreamBannerPlace}
            sponsorCornerBannerPlace={sponsorCornerBannerPlace}
            setInStreamBannerHeight={setInStreamBannerHeight}
            setCornerBannerHeight={setCornerBannerHeight}
          />

          <SponsorPauseAdv
            fullscreenTarget={fullscreenTarget}
            videoState={videoState}
            content={content}
            rightholderId={content.rightholder?.id}
            sponsorVideoPlace={sponsorVideoPlace}
            muted={muted}
          />
        </>
      )}
    </>
  );
}

ChannelScreenContent.propTypes = {
  content: channelContentShape.isRequired,
  videoState: videoStateShape,
  videoActions: videoActionsShape,
  fullscreenTarget: PropTypes.string,
  muted: PropTypes.bool,
  autoPlay: PropTypes.bool,
  controls: PropTypes.bool,
  sponsorCornerBannerPlace: PropTypes.string,
  sponsorInStreamBannerPlace: PropTypes.string,
  sponsorPlayerLogoPlace: PropTypes.string,
  sponsorPlayerButtonPlace: PropTypes.string,
  sponsorVideoPlace: PropTypes.string,
  closeRouteDialogButton: PropTypes.node,
};
